import React, { useState, useEffect } from 'react';

function Maintenance() {
  const technicians = [
    'Jane Smith',
    'Sarah Davis',
    'Laura Martinez',
    'Tom Clark',
    'Mark Anderson',
    'Lisa White',
    'John Doe',
    'Emily Brown'
  ];

  const statuses = [
    { status: 'Busy', statusClass: 'status-pending' },
    { status: 'On Leave', statusClass: 'status-overdue' },
    { status: 'Available', statusClass: 'status-completed' }
  ];

  const initialMaintenanceData = [
    { component: 'Membrane', technician: 'Jane Smith', status: 'Busy', mobile: '+91 98765-43211', email: 'jane.smith@example.com', statusClass: 'status-pending' },
    { component: 'Raw Water Tank', technician: 'Sarah Davis', status: 'On Leave', mobile: '+91-98765-43215', email: 'sarah.davis@example.com', statusClass: 'status-overdue' },
    { component: 'Membrane', technician: 'Laura Martinez', status: 'Busy', mobile: '+91-98765-43217', email: 'laura.martinez@example.com', statusClass: 'status-pending' },
    { component: 'Membrane', technician: 'Tom Clark', status: 'Available', mobile: '+91-98765-43218', email: 'tom.clark@example.com', statusClass: 'status-completed' },
    { component: 'RO Pump', technician: 'Mark Anderson', status: 'Available', mobile: '+91-98765-43220', email: 'mark.anderson@example.com', statusClass: 'status-completed' },
    { component: 'Treated-Water-Tank', technician: 'Lisa White', status: 'On Leave', mobile: '+91-98765-43221', email: 'lisa.white@example.com', statusClass: 'status-overdue' },
  ];

  const [maintenanceData, setMaintenanceData] = useState(initialMaintenanceData);
  const [isMobile, setIsMobile] = useState(false);

  // Check for mobile view
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Function to update technician names
  const updateTechnicianNames = () => {
    setMaintenanceData(prevData =>
      prevData.map(item => ({
        ...item,
        technician: technicians[Math.floor(Math.random() * technicians.length)]
      }))
    );
  };

  // Function to update technician statuses
  const updateTechnicianStatuses = () => {
    setMaintenanceData(prevData =>
      prevData.map(item => {
        const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];
        return {
          ...item,
          status: randomStatus.status,
          statusClass: randomStatus.statusClass
        };
      })
    );
  };

  // Effect for updating technician names every 1 hour
  useEffect(() => {
    updateTechnicianNames(); // Initial update
    const nameInterval = setInterval(updateTechnicianNames, 3600000); // 1 hour = 3600000 ms
    return () => clearInterval(nameInterval); // Cleanup
  }, []);

  // Effect for updating technician statuses every 10 minutes
  useEffect(() => {
    updateTechnicianStatuses(); // Initial update
    const statusInterval = setInterval(updateTechnicianStatuses, 600000); // 10 minutes = 600000 ms
    return () => clearInterval(statusInterval); // Cleanup
  }, []);

  // Inline styles for table responsive
  const tableResponsiveStyle = {
    overflowX: 'auto',
    marginTop: '20px'
  };

  // Inline styles for cards
  const cardStyle = {
    backgroundColor: 'white',
    padding: '15px',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    marginBottom: '15px',
    borderLeft: '4px solid #06b6d4'
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
    flexWrap: 'wrap'
  };

  const componentStyle = {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: '5px'
  };

  const statusStyle = {
    padding: '5px 10px',
    borderRadius: '15px',
    fontSize: '0.9rem',
    fontWeight: '600'
  };

  const bodyStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  };

  const infoStyle = {
    fontSize: '0.9rem',
    color: '#6b7280',
    margin: '0'
  };

  // Render table for desktop
  const renderTable = () => (
    <div style={tableResponsiveStyle}>
      <table className="maintenance-table">
        <thead>
          <tr>
            <th>Components</th>
            <th>Technician Name</th>
            <th>Technician Status</th>
            <th>Mobile No</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          {maintenanceData.map((item, index) => (
            <tr key={index}>
              <td>{item.component}</td>
              <td>{item.technician}</td>
              <td><span className={`stat-status ${item.statusClass}`} style={statusStyle}>{item.status}</span></td>
              <td><a href={`tel:${item.mobile}`}>{item.mobile}</a></td>
              <td><a href={`mailto:${item.email}`}>{item.email}</a></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  // Render cards for mobile
  const renderCards = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '20px' }}>
      {maintenanceData.map((item, index) => (
        <div key={index} style={cardStyle}>
          <div style={headerStyle}>
            <h3 style={componentStyle}>{item.component}</h3>
            <span className={`stat-status ${item.statusClass}`} style={statusStyle}>{item.status}</span>
          </div>
          <div style={bodyStyle}>
            <p style={infoStyle}><strong>Technician:</strong> {item.technician}</p>
            <p style={infoStyle}><strong>Mobile:</strong> <a href={`tel:${item.mobile}`}>{item.mobile}</a></p>
            <p style={infoStyle}><strong>Email:</strong> <a href={`mailto:${item.email}`}>{item.email}</a></p>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="content-card">
      <h2>
        <i className="fas fa-tools"></i> Maintenance Details
      </h2>
      {isMobile ? renderCards() : renderTable()}
    </div>
  );
}

export default Maintenance;